import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from "@/views/Home"
import About from "@/views/About"
import News from "@/views/News"
import Contact from "@/views/Contact"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home",
    name: "主页",
    component: Home
  },
  {
    path: "/about",
    name: "关于我们",
    component: About
  },
  {
    path: "/news",
    name: "新闻",
    component: News
  },
  {
    path: "/contact",
    name: "联系我们",
    component: Contact
  },
  {
    path: "*",
    redirect: "/home"

  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
